import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[sparkPasteNumbersOnly]'
})
export class SparkPasteNumbersOnlyDirective {
  @Output() sparkPasteNumbersOnly = new EventEmitter<string>();

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const pastedText = event.clipboardData?.getData('Text') || '';
    const numbersOnly = pastedText.replace(/\D/g, '');

    const input = event.target as HTMLInputElement | null;
    if (input?.value !== undefined) {
      input.value = numbersOnly;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    this.sparkPasteNumbersOnly.emit(numbersOnly);
  }
}
